import React from 'react';

const About = (props) => {
  return (
    <div className={`${props.scrollLock ? "position-fixed" : ""}`}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '90vh'
      }}
    >
      <h1>About</h1>
    </div>
  );
};

export default About;
